import React from "react";
import {
  trackEvent,
  EVENT_CATEGORY,
  EVENT_TYPE,
} from "@lululemon/mwa-analytics";
import { withErrorBoundary } from "@lululemon/mwa-common";
import { Button } from "@lululemon/ecom-pattern-library-button";
import { BrandStatement } from "@lululemon/ecom-pattern-library-brand-statement";
import { GridContainer } from "@lululemon/ecom-pattern-library-grid-container";
import useShowWMTM from "../v2/breadcrumbs/use-show-WMTM";
import PdpWMTMBannerStatement from "./pdp-WMTM-brand-statement";

const PDPBrandStatement = () => {
  const fireTracking = () => {
    trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, {
      eventSubType: EVENT_TYPE.INTERACTION,
      component: {
        id: "digital-educator-cta",
        type: "Button",
        text: "Book Now CTA",
        position: 1,
        totalCount: 1,
      },
    });
  };

  const shouldDisplayWMTM = useShowWMTM();

  return shouldDisplayWMTM ? (
    <PdpWMTMBannerStatement />
  ) : (
    <GridContainer layout="1 Column - Wide">
      <BrandStatement
        ctaButton={
          <Button
            onClick={() => fireTracking()}
            data-component-link="global-brand-statement"
            href="https://www.lululemon-virtualshopping.com/"
            // external domains must have rel=nofollow for SEO
            rel="nofollow"
          >
            Book Now
          </Button>
        }
        editorialCopy="Whether you’ve got questions about product or you just miss us, our educators are online and ready to chat."
        headline="(Virtual) personal shopping is here"
        imageProps={{
          maxWidth: 2644,
          src: "https://images.lululemon.com/is/image/lululemon/2023_PDP_Brand%20Statement_D",
        }}
        mobileImageProps={{
          maxWidth: 746,
          src: "https://images.lululemon.com/is/image/lululemon/2023_PDP_Brand%20Statement_M",
        }}
      />
    </GridContainer>
  );
};

PDPBrandStatement.displayName = "PDPBrandStatement";

PDPBrandStatement.defaultProps = {};

PDPBrandStatement.propTypes = {};

export default withErrorBoundary({ componentName: "PDP Brand Statement" })(
  PDPBrandStatement
);
